import { fromClass } from "fw-model";
import { SearchResult } from "../search-result";

export class TransferPlannerDetectionSummaryMetaData {
    IsLatest: boolean;
    DateCreatedUtc: Date;
    DateUpdatedUtc: Date;
}

export class TransferPlannerRouterDetectionSummary {
    Id: string;
    RouterId: string;
    RouterName: string;

    // Organizations counts
    OrganizationsVerified: number;
    OrganizationsSkipped: number;

    // Tracks profiles states
    ProfilesVerified: number;
    ProfilesUnableToVerify: number;
    ProfilesUnroutable: number;
    ProfilesUnroutableProfileIds: string[];
    ProfilesNonMinViable: number;
    ProfilesMissing: number;
    ProfilesVersionMismatch: number;
    ProfilesOrphaned: number;
    ProfilesOrphanDeleted: number;

    // The track the action taken
    RoutingExpressionErrors: number;
    RoutingExpressionErrorsProfileIds: string[];
    TransformExpressionErrors: number;
    TransformExpressionErrorsProfileIds: string[];
    ProfilesDelivered: number;
    ProfilesDeliveryErrors: number;
    ProfilesDeliveryErrorsProfileIds: string[];
    ProfilesTSPCampusStatusOverride: number;

    @fromClass MetaData: TransferPlannerDetectionSummaryMetaData;
}

export class TransferPlannerRouterDetectionSummarySearchResult extends SearchResult<TransferPlannerRouterDetectionSummary> {}
